'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { FC, PropsWithChildren } from 'react';

import { ArkProvider } from '@sola/ark-core/contexts/ark.js';
import { AuthProvider } from '@sola/auth-sdk/components/auth-provider.js';
import { Sites, getPublicConfig } from '@sola/config/lib/getters.js';

import { RandomChildProvider } from '../random-child/provider.jsx';

export const SkippyProviders: FC<
  PropsWithChildren<{
    locale?: string;
  }>
> = ({ children, locale }) => {
  const publicConfig = getPublicConfig();
  const includeAuthProvider =
    publicConfig.NEXT_PUBLIC_SITE_ID !== Sites.enum.compex;
  const queryClient = new QueryClient();

  const content = (
    <QueryClientProvider client={queryClient}>
      <ArkProvider locale={locale}>
        <RandomChildProvider>{children}</RandomChildProvider>
      </ArkProvider>
    </QueryClientProvider>
  );

  return includeAuthProvider ? <AuthProvider>{content}</AuthProvider> : content;
};
